import {Component, Input} from '@angular/core';

import {
  INGENIEROSAGRONOMOSCOREDETAIL_DEFAULT_FIELDS,
  IngenierosCoreDetailParams, PERSONASCOREDETAIL_DEFAULT_FIELDS,
} from '../../../models';
import {DetailField, DetailParams, formatValue} from '../../../../shared';
import {CONTACTO_DETAIL_DEFAULT_FIELDS} from "../../../constants";

@Component({
  selector: 'app-ingeniero-agronomo-detail',
  templateUrl: './ingeniero-agronomo-detail.component.html',
  styleUrls: ['./ingeniero-agronomo-detail.component.scss']
})
export class IngenieroAgronomoDetailComponent {
  @Input() title: string = null;
  fields: DetailField[] = [];
  detailParams: DetailParams = null;

  constructor() {
  }

  _params: IngenierosCoreDetailParams = null;

  @Input()
  set params(value: IngenierosCoreDetailParams) {
    this._params = value;
    if (!value) {
      return;
    }

    const fieldsIngeniero = value.fields || INGENIEROSAGRONOMOSCOREDETAIL_DEFAULT_FIELDS;
    const rowsIngeniero = fieldsIngeniero.map(f => ({
      label: f.label,
      value: value.ingeniero[f.name]
    }));

    this.detailParams = {
      rows: rowsIngeniero
    };

    if (value.persona) {
      const fieldsPersona = value.fields || PERSONASCOREDETAIL_DEFAULT_FIELDS;
      const rowsPersona = fieldsPersona.map(f => ({
        label: f.label,
        value: formatValue(value.persona[f.name], f.format)
      }));
      this.detailParams.rows = [...this.detailParams.rows,...rowsPersona];
    }

    if (value.ingeniero) {
      const fieldsContacto = value.fields || CONTACTO_DETAIL_DEFAULT_FIELDS;
      const rowsContacto = fieldsContacto.map(f => ({
        label: f.label,
        value: formatValue(value.ingeniero.contacto[f.name], f.format)
      }));
      this.detailParams.rows = [...this.detailParams.rows,...rowsContacto];
    }
  }
}
